import qs from 'qs';
import product from 'src/common/config/product';
import get from 'lodash/get';
import { localiseUrl } from 'src/common/utils/format-localised-url';

const buildProductUrl = (props, options) => {
  const productSlug = product.getProductByKey(props.productKey).slug;
  const countryModel = props.model.countryModel;
  const browserQuery = get(props, 'history.location.search', '');

  let url = `/personalized-products/${productSlug}`;
  let search = qs.stringify({
    ...qs.parse(browserQuery, { ignoreQueryPrefix: true }),
    ...props.queryParams,
    ...options.queryParams,
  }, { addQueryPrefix: true });

  switch (options.type) {
    case 'cart':
      url = '/cart';
      search = '';
      break;
    default:
      url += `/${options.type}`;
      if (options.itemId) {
        url += `/${options.itemId}`;
      }
      break;
  }

  return localiseUrl(countryModel, `/${url}${search}`);
};

export default buildProductUrl;



// WEBPACK FOOTER //
// ./src/client/js/view/utils/buildProductUrl.js